import { Stack, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const GetStarted = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tab = location.pathname.endsWith("/upload") ? 1 : 0;

  const handleChangeTab = (_: React.SyntheticEvent, newValue: number) => {
    if (newValue === 0) navigate("country");
    if (newValue === 1) navigate("upload");
  };

  return (
    <Stack
      pt="2.625rem"
      minHeight="100vh"
      gap="2rem"
      width="100%"
      alignItems="center"
    >
      <Stack maxWidth="720px" direction="column" gap="2rem">
        <Stack
          sx={{
            width: "100%",
            height: "auto",
            gap: 1.5,
          }}
        >
          <Typography
            variant="display4"
            lineHeight={{
              xl: "2.625rem",
              lg: "2.5rem",
            }}
            textAlign="left"
          >
            Get started
          </Typography>
          <Typography variant="subtitle1" textAlign="left" color="secondary">
            Define your target area and period to filter the data for your need.
            Continue by either selecting a target country or choose to upload
            your own shape file. Countries are grouped into{" "}
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#E8F5E9",
                    border: "1px solid #43A047",
                    color: "#515167",
                  },
                },
              }}
              title="Quality-controlled loss data and climate data validated for drought risk financing."
            >
              <u style={{ color: "#43A047" }}>Tier 1</u>
            </Tooltip>
            ,{" "}
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#FFF3E0",
                    border: "1px solid #FB8C00",
                    color: "#515167",
                  },
                },
              }}
              title="Climate data integrated and under evaluation; financial products in development."
            >
              <u style={{ color: "#FB8C00" }}>Tier 2</u>
            </Tooltip>{" "}
            and{" "}
            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#F3E5F5",
                    border: "1px solid #8E24AA",
                    color: "#515167",
                  },
                },
              }}
              title="Available climate data not yet validated for drought risk finance."
            >
              <u style={{ color: "#8E24AA" }}>Tier 3</u>
            </Tooltip>{" "}
            based on the availability and validation of climate and loss data,
            as well as their involvement in developing financial products.
          </Typography>
        </Stack>
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          variant="fullWidth"
          sx={{
            width: "100%",
            borderBottom: "1px solid #E8E8ED",
            "& .MuiTab-root": {
              textTransform: "none",
              color: "#555",
            },
            "& .MuiTab-root.Mui-selected": {
              color: "#2146A4",
            },
            "& .MuiTabs-indicator": {
              borderBottom: "2px solid #2146A4",
            },
          }}
        >
          <Tab
            value={0}
            label={
              <Stack direction="row" alignItems="center" gap={1}>
                <TravelExploreIcon
                  sx={{ color: tab === 0 ? "#2146A4" : undefined }}
                />
                <Stack direction="column" justifyContent="flex-start">
                  <Typography textAlign="left">
                    Select a target country
                  </Typography>
                  <Typography
                    variant="caption"
                    textAlign="left"
                    color="#515167"
                  >
                    Open
                  </Typography>
                </Stack>
              </Stack>
            }
            sx={{ textTransform: "none" }}
          />
          <Tab
            value={1}
            label={
              <Stack direction="row" alignItems="center" gap={1}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="22"
                  viewBox="0 0 23 22"
                  fill="none"
                >
                  <path
                    d="M0 8.1L4.3 21.2H18.1L22.4 8.1L11.2 0L0 8.1ZM11.3 2.6L19.2 8.3L9.1 9.8L11.3 2.6ZM2.9 8.5L10 3.3L8 9.8L2.9 8.5ZM16.8 18.9L9.3 10.8L19.9 9.2L16.8 18.9ZM15.8 19.3H6.1L8.5 11.5L15.8 19.3ZM2.5 9.4L7.7 10.8L5.4 18.3L2.5 9.4Z"
                    fill={tab === 1 ? "#2146A4" : "#515167"}
                  />
                </svg>
                <Stack direction="column" justifyContent="flex-start">
                  <Typography textAlign="left">Upload a shapefile</Typography>
                  <Typography
                    variant="caption"
                    textAlign="left"
                    color="#515167"
                  >
                    Login
                  </Typography>
                </Stack>
              </Stack>
            }
            sx={{ textTransform: "none" }}
          />
        </Tabs>
      </Stack>
      <Outlet />
    </Stack>
  );
};

export default GetStarted;
